const Footer = () => {
  return (
  <div id="Footer">
    <div className="row d-flex flex-column flex-lg-row">
      <div className="col-12 mobile d-block d-lg-none">
        <p className="title col">Company</p>
        <a href="/" className="link col">About</a>
        <a href="/" className="link col">Newsroom</a>
        <a href="/" className="link col">Contact</a>
        <a href="/" className="link col">Careers</a>
        <a href="/" className="link col">ByteDance</a>
        <a href="/" className="title col">Programs</a>
        <a href="/" className="link col">TikTok for Good</a>
        <a href="/" className="link col">Advertise</a>
        <a href="/" className="link col">Developers</a>
        <a href="/" className="title col">Resources</a>
        <a href="/" className="link col">Help Center</a>
        <a href="/" className="link col">Safety Center</a>
        <a href="/" className="link col">Creator Portal</a>
        <a href="/" className="link col">Community Guidelines</a>
        <a href="/" className="link col">Transparency</a>
        <a href="/" className="link col">Accessibility</a>
        <a href="/" className="title col">Legal</a>
        <a href="/" className="link col">Terms of Service</a>
        <a href="/" className="link col">Privacy Policy</a>
      </div>
      <div className="col-12 desktop d-none d-lg-block">
        <div href="/" className="col-12">
          <a href="/" className="link">About</a>
          <a href="/" className="link">Newsroom</a>
          <a href="/" className="link">Contact</a>
        </div>
        <div className="col-12">
          <a href="/" className="link">TikTok for Good</a>
          <a href="/" className="link">Advertise</a>
          <a href="/" className="link">Developers</a>
          <a href="/" className="link">Transparency</a>
        </div>
        <div className="col-12">
          <a href="/" className="link">Help</a>
          <a href="/" className="link">Safety</a>
          <a href="/" className="link">Terms</a>
          <a href="/" className="link">Privacy</a>
          <a href="/" className="link">Creator Portal</a>
          <a href="/" className="link">Community Guidelines</a>
        </div>
      </div>
      </div>
      </div>
      )
}
export default Footer